// todo: add toc
export default function Works() {
	return (
		<div className="container mx-auto py-2">
			<h1 className="mb-3 text-5xl">Work Experience</h1>
			{works.map(work => Work(work))}
		</div>
	)
}

function Work(work: Work) {
	return (
		<div key={work.position + work.companyName} className="mb-5">
			<h2 className="text-3xl">{work.position}</h2>
			<h3 className="text-xl">{work.companyName}</h3>
			<p className="mb-2">
				{work.startDate} - {work.endDate}
			</p>
			<ul className="list-inside list-disc">
				{work.body.map(line => (
					<li key={line}>{line}</li>
				))}
			</ul>
			{work.awards ? (
				<div className="mt-4">
					<h4>Awards</h4>
					<ul className="list-inside list-disc">
						{work.awards.map(award => (
							<li key={award.title}>{award.date + ' ' + award.title}</li>
						))}
					</ul>
				</div>
			) : null}
		</div>
	)
}

type Work = {
	companyName: string
	position: string
	location: string
	startDate: string
	endDate: string
	body: string[]
	awards?: { date: string; title: string }[]
}

const works: Work[] = [
	{
		companyName: 'Daniel Arrizza Consulting',
		position: 'Data Engineering Consultant and Trainer',
		startDate: 'March 2023',
		endDate: 'Present',
		location: 'Toronto, ON',
		body: [
			'Databricks Authorized Training Partner',
			'Training data engineers and data scientists in Spark, Delta Lake, and data engineering on Databricks',
			'Helping companies build data pipelines and data lakes',
		],
		awards: [
			{ date: 'Feb 2022', title: 'Teamwork' },
			{ date: 'Apr 2021', title: 'Let the Data Decide' },
			{ date: 'Mar 2021', title: 'Delta and Performance SME' },
			{ date: 'Jul 2020', title: 'Teamwork' },
			{ date: 'Feb 2020', title: 'Win Production Workloads with Delta Lake' },
		],
	},
	{
		companyName: 'Databricks',
		position: 'Sr Staff Customer Success Engineer',
		startDate: 'March 2019',
		endDate: 'March 2023',
		location: 'Toronto, ON',
		body: [
			'Lent expertise to enterprise customers in Spark, Lakehouse, big data, analytics, and cloud technologies (AWS/Azure/GCP)',
			'Taught certification webinars to thousands of customers in Data Engineering, Data Analytics, Platform Admin',
			'Taught Advanced Data Engineering with Databricks at Data + AI Summit',
			'Key technical SME for adoption of our Delta Lake product. Created GTM materials, ran workshops, built internal dashboards',
			'Built a customer-facing analysis tool that diagnoses platform issues and suggests enterprise best practices',
			'Developed an internal customer insights tool using ReactJS to help with forecasting, attribution, and account strategy',
			'Improved the new product release processes and coordinated product migrations',
			'Managed a team of Customer Success Engineers to achieve targets for enterprise clients on renewal rates, customer satisfaction, expansions, upsells, and new opportunities',
		],
	},
	{
		companyName: 'AppDynamics',
		position: 'Senior Consultant',
		startDate: 'Apr 2017',
		endDate: 'Mar 2019',
		location: 'Toronto, ON',
		body: [
			'Lead technical resource on complex enterprise IT implementation of APM (Application Performance Management) software',
			'Cultivated deep relationships with customer stakeholders and champions - act as a trusted advisor towards both their technical and business goals',
			'Increased adoption of the tool throughout client enterprise accounts',
			'Developed internal tools as a side-project for creating client dashboards and data warehousing',
			'Acted as an internal thought-leader around business analytics and browser monitoring',
			'Mentored new and junior members of the team',
		],
	},
]
